import { Adapter } from "@app/shared/models/adapter.model";

export interface Environment {
  id: string;
  description: string;
}

export interface AvatarEnvironment {
  avatar: string;
  name: string;
  language: string;
  environmentList: Environment[];
}

export class EnvironmentAdapter implements Adapter<Environment[]> {
  adapt(rawData: any): Environment[] {
    return rawData.environmentList;
  }
}

export class AvatarEnvironmentAdapter implements Adapter<AvatarEnvironment> {
  adapt(rawData: any): AvatarEnvironment {
    return rawData;
  }
}
